import { StandardError } from "@core-ts/StandardError"

export function enableExperimentalFeatures(): boolean {
    const query = window.location.search.substring(1)
    const vars = query.split("&")

    for (const v of vars) {
        const pair = v.split("=")

        if (pair[0] === "exp") {
            return pair[1] === "1"
        }
    }
    return false
}

const servicePaths: Record<string, string> = {}

export function setServicePath(service: string, path: string): void {
    servicePaths[service] = path
}

export function getServicePath(service: string): string {
    if (!(service in servicePaths)) throw new StandardError("Path not set for service " + service)

    return servicePaths[service]
}
